import Store from '../store/index.js';
import { includes, get, every, head } from 'lodash';
import { isUsingKc } from '../utils';

export function useRouter() {
    async function beforeEnter(to, from, next) {
        const establishmentId = to.params.establishmentId;
        Store.commit('gap/SET_GAP_MODE', to.query.gapMode);
        Store.commit('gap/SET_GAP_HEAD_OFFICE_ID', to.query.gapHeadOfficeId);

        // validate establishment id in the url
        if (parseInt(establishmentId)) {
            try {
                if (!isUsingKc) {
                    await Store.dispatch('jwt/fetchAccessToken');
                    await Promise.all([
                        Store.dispatch('jwt/getLoggedUser'),
                        Store.dispatch('jwt/getLoggedUserCommunication'),
                        Store.dispatch('jwt/getPatients'),
                    ]);
                }
            }
            catch(error) {
                // Silent refresh token error
            }

            try {
                // get establishment infos
                await Store.dispatch('establishment/getEstablishment', establishmentId);
                await Promise.all([
                    Store.dispatch('texts/getTexts', establishmentId),
                    Store.dispatch('establishment/getAllModules'),
                    Store.dispatch('services/getInstantiateServices'),
                    Store.dispatch('places/getPlaces'),
                ]);

                if (to.query.unifiedService) {
                    const unifiedServiceId = to.query.unifiedService;
                    await Store.dispatch('services/getDynamicServiceFilters', { establishmentId, unifiedServiceId });
                }
                else if (parseInt(get(to, 'query.category')) && !parseInt(get(to, 'query.portalEst'))) {
                    await Store.dispatch(
                        'services/getEstServiceUnifiedAssociationsByServiceUnified', {
                            establishmentId: to.params.establishmentId,
                            serviceUnifiedId: to.query.category,
                        });
                }
                else if (parseInt(get(to, 'query.serviceTemplate')) && !parseInt(get(to, 'query.portalEst'))) {
                    await Store.dispatch('services/setServicesFilteredByServiceTemplateIds', to.query.serviceTemplate);
                }
                else {
                    if(to.path === `/${establishmentId}/take-appt`) {
                        let dynamicFilters = await Store.dispatch('establishment/getDynamicServiceFilters', { establishmentId });

                        if(dynamicFilters && dynamicFilters.length > 0 && every(dynamicFilters, ['id', head(dynamicFilters).id])) {
                            if(to.query.portalServicesUnified?.split(',').some(id =>
                                dynamicFilters.some(filter => filter.serviceUnified === parseInt(id))
                            )) {
                                const unifiedServiceId = dynamicFilters[0].serviceUnified;
                                await Store.dispatch('services/getDynamicServiceFilters', { establishmentId, unifiedServiceId, ignoreUnifiedServiceSet: true });
                            }
                        }
                        else {
                            // TODO : we can't handle this case and will be a task to do later after the visibility project
                        }
                    }
                }

                // Unset page blocked if it's true
                // @ts-ignore
                if (Store.getters['getPublicPageBlocked']) {
                    await Store.commit('SET_PUBLIC_PAGE_BLOCKED', false);
                }

                next();
                return;
            }
            catch(e) {
                if (get(e, 'internalCode') === 'service_unified.not_found') {
                    next(`${establishmentId}/take-appt`);
                    return;
                }
                if (get(e, 'internalCode', '') === 'service-unavailable.shedding-page') {
                    await Store.commit('SET_PUBLIC_PAGE_BLOCKED', true);
                    next();
                    return;
                }
            }
        }
        next('/not-found');
    }

    async function beforeEach(to, from, next) {
        const host = window.location.hostname;

        await Store.dispatch('loading/toggleHomeLoading', { set: true });

        // set product style
        if (includes(host, 'localhost') >= 0 && to.query.style != null) {
            Store.commit('UPDATE_STYLE', to.query.style);
        }
        else if (includes(host, 'pharmaprix')) {
            Store.commit('UPDATE_STYLE', 'pharmaprix');
        }
        if (to.query.portalEst) {
            await Store.dispatch('services/setPortalEst', to.query.portalEst);
        }
        next();
    }

    return {
        beforeEnter,
        beforeEach
    };
}
